import React from 'react';
import classNames from 'classnames';

import FormFieldError from './FormFieldError';
import FormFieldLabel from './FormFieldLabel';
import FormFieldTooltip, { TooltipSource } from './FormFieldTooltip';
import useFormField, { FieldEvent, FieldWidth } from './useFormField';

interface IProps {
  name: string;
  label: string;
  value?: string;
  tooltip?: TooltipSource;
  disabled?: boolean;
  width?: FieldWidth;
  onFocus?: FieldEvent<string>;
  onChange?: FieldEvent<string>;
  onBlur?: FieldEvent<string>;
}

function FormCheckboxField({
  name,
  label,
  value,
  tooltip,
  disabled,
  width,
  onFocus,
  onChange,
  onBlur,
}: IProps) {
  const {
    id,
    fieldProps,
    inputProps,
    required,
    disabled: formDisabled,
  } = useFormField<string>(name, width, { onFocus, onChange, onBlur });

  const fieldId = `${id}_${value || ''}`;
  const fieldClassName = classNames(fieldProps.className, 'novoFormField--checkbox');
  const defaultChecked =
    inputProps.value && Array.isArray(inputProps.value) ? inputProps.value.includes(value) : inputProps.value;

  return (
    <div {...fieldProps} className={fieldClassName}>
      <input
        data-testid="formCheckboxField"
        className="novoFormField__input"
        id={fieldId}
        type="checkbox"
        {...inputProps}
        value={value}
        defaultChecked={defaultChecked}
        disabled={formDisabled || disabled}
        required={required}
      />

      <FormFieldLabel for={fieldId} required={required}>
        {label}
        <FormFieldError name={name} />
      </FormFieldLabel>
      <FormFieldTooltip source={tooltip} />
    </div>
  );
}

export default FormCheckboxField;
